// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"586":"25a312d9","1187":"25a312d9","2012":"25a312d9","2506":"25a312d9","4299":"25a312d9","5335":"f29eb1cd","6536":"25a312d9","7255":"25a312d9","7875":"25a312d9"}[chunkId] + ".chunk.css";
};